import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { useContent } from "../hooks/useContent";
import { useSeo } from "../components/SEO";
import PageHero from "../components/PageHero";
import { Section, StatusBadge } from "../components/Primitives";
import { Utensils, HandHeart, Sparkles, Stethoscope, Flower2, ClipboardPlus, Car, Scissors } from "lucide-react";

const ICONS = { utensils: Utensils, "hand-heart": HandHeart, sparkles: Sparkles, stethoscope: Stethoscope,
  flower: Flower2, "clipboard-plus": ClipboardPlus, car: Car, scissors: Scissors };

export default function Services() {
  const { t, pick } = useI18n();
  useSeo(t("nav.services"), "Services et accompagnement à la Résidence Doux Instants : repas, soins 24/7, aide domestique et plus. Statut clair par service.");
  const { data: services = [] } = useContent("services");

  const legend = ["inclus", "offert", "supplement", "sur_evaluation", "non_offert"];

  return (
    <>
      <PageHero eyebrow={t("nav.services")} title={t("home.servicesTitle")} subtitle={t("home.servicesIntro")}
        image="https://images.pexels.com/photos/18509799/pexels-photo-18509799.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" />
      <Section tone="surface">
        <div className="mb-8 flex flex-wrap gap-2" data-testid="services-legend">
          {legend.map((s) => <StatusBadge key={s} status={s} label={t(`serviceStatus.${s}`)} />)}
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="services-grid">
          {services.map((s) => {
            const Icon = ICONS[s.icon] || Sparkles;
            return (
              <div key={s.id} className="flex flex-col rounded-2xl border border-black/5 bg-white p-6 transition-transform hover:-translate-y-1">
                <div className="flex items-start justify-between gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#2A9D8F]/10">
                    <Icon className="h-6 w-6 text-[#2A9D8F]" />
                  </span>
                  <StatusBadge status={s.status} label={t(`serviceStatus.${s.status}`)} />
                </div>
                <h3 className="mt-4 font-display text-xl">{pick(s.name)}</h3>
                <p className="mt-2 text-[15px] text-[#5C6370]">{pick(s.desc)}</p>
              </div>
            );
          })}
        </div>
      </Section>
    </>
  );
}
